import { AnyAction } from "redux";

import * as constants from "./constants";

const initState = {
  nickname: "",
  email: "",
  accessToken: "",
  captchaType: undefined,
};

export default function reducers(state = initState, action: AnyAction) {
  switch (action.type) {
    // 修改页面内容
    case constants.SAVE_REGISTER_INFO:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
